import React from 'react'
import Button from '../Design/Button'

const NextPrev = props => {
  const { setTransition, setIndex, index, length } = props

  const handleSelection = (selection, index) => {
    if (selection === 'next') {
      setTransition('fade-out-left')
      setTimeout(() => {
        setIndex(index + 1)
        setTransition('fade-in-left')
      }, 90)
    } else {
      setTransition('fade-out-right')
      setTimeout(() => {
        setIndex(index - 1)
        setTransition('fade-in-right')
      }, 90)
    }
  }

  const next = (<Button addClass='next-prev-button right' clicked={() => handleSelection('next', index)} text=' &gt; ' />)
  const prev = (<Button addClass='next-prev-button left' clicked={() => handleSelection('prev', index)} text=' &lt; ' />)
  const prevNext = (
    <div style={{ width: '100%' }}>
      {prev}
      {next}
    </div>
  )

  return (
    <div>
      {
        index === 0 && length === 1
          ? <span />
          : index === 0 && length > 1
            ? next
            : index > 0 && index + 1 === length
              ? prev
              : prevNext
      }
    </div>
  )
}

export default NextPrev
